export interface DeliveryTier {
  price_from: number;
  price: number;
}

export interface SmallOrderFeeResult {
  tier: DeliveryTier;
  fee: number;
  isFeeApplied: boolean;
}

interface calcSmallOrderFeeParams {
  tiers?: DeliveryTier[];
  cartSubtotal: number;
  currentDeliveryAmount: number;
}

export function calcSmallOrderFee({
  tiers,
  cartSubtotal,
  currentDeliveryAmount,
}: calcSmallOrderFeeParams): SmallOrderFeeResult {
  if (!tiers || !tiers.length) {
    return {tier: {price: 0, price_from: 0}, fee: 0, isFeeApplied: false};
  }

  if (cartSubtotal >= 200) {
    return {tier: {price: 0, price_from: 0}, fee: 0, isFeeApplied: false};
  }

  const tier = tiers.find((t) => cartSubtotal < t.price_from) ?? tiers[tiers.length - 1];

  if (tier.price === 0) {
    return {tier, fee: 0, isFeeApplied: false};
  }

  const fee = Math.max(0, currentDeliveryAmount - tier.price);
  return {tier, fee, isFeeApplied: fee > 0};
}
